class LightingSwitch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="checkbox"]');
  }

  connectedCallback() {
    if (!this.input) return;

    this.input.addEventListener(
      'change',
      this.handleChange.bind(this)
    );

    // Initial state based on current time
    this.updateLightingByTime();

    // Check time periodically
    this.timeInterval = setInterval(() => {
      this.updateLightingByTime();
    }, 60 * 1000); // Every 1 minute
  }

  disconnectedCallback() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }

  handleChange() {
    this.updateLighting();
  }

  updateLighting() {
    const isLightOn = this.input.checked;

    document.documentElement.classList.toggle(
      'lighting-mode',
      isLightOn
    );

    document.body.classList.toggle(
      'lighting-mode',
      isLightOn
    );
  }

  updateLightingByTime() {
    const now = new Date();
    const currentHour = now.getHours();

    /*
      ON  = 6:00 PM (18:00)
      OFF = 7:00 AM (07:00)

      Lighting ON time:
      18:00 → 23:59
      00:00 → 06:59

      Lighting OFF time:
      07:00 → 17:59
    */

    const shouldBeOn =
      currentHour >= 18 || currentHour < 7;

    this.input.checked = shouldBeOn;

    this.updateLighting();
  }
}

if (!customElements.get('lighting-switch')) {
  customElements.define('lighting-switch', LightingSwitch);
}